
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const bax2020Classic: IProductData = {
  id: "popeaudio-bax2020-classic",
  name: "BAX 2020 Classic",
  description: "Classic Baxendall style EQ and drive.",
  specialOrder: true,
  images: ["/img/bax_beast.jpg", "/img/bax_stripes.jpg"],
  details: [{
    label: "Description",
    markdown: `
The Baxandall equaliser is a simple shelving EQ, but unlike traditional shelving EQs a Baxandall exhibits a gently rising slope for a more natural sound, and lower phase distortion.  
Perfect for adding top-end sparkle to a mix or stem, gently rolling off low-end mud on complex acoustic instruments or driving the input harder for subtle harmonic colouration.
Available in several configurations, Classic, Extra and Beast.  
Each model features a different arrangement of opamp and transformer combinations, depending on whether you’re looking for a super clean and natural sound or want to drive the unit for more harmonic character and saturation on bass-heavy material.  

Pope Audio BAX 2020 'Classic' combines analog 'Hi' & 'Lo' frequency gain control, in a compact, fuss-free module.  
When not required in the signal path, the unit is in hard bypass, meaning that the signal is left 100% unaffected by the unit.  
`
  }, {
    label: "Features",
    markdown: `
- GAR2520 input DOA (discrete op-amp)
- NE5532 output IC
- True Bypass
- Hand-built in U.K.
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.popeaudio.co.uk/general-1-1-1" target="_blank">https://www.popeaudio.co.uk/general-1-1-1</a>
    `
  }],
  videos: ["https://www.youtube.com/embed/yoSFYa9A3LI?si=e8Yj6WySVHUt0_n2"],
  metadata: {
    hashtags: [HASHTAGS.EQ, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.SINGLE_SLOT, HASHTAGS.API_500, HASHTAGS.MASTERING],
    manufacturer: BRAND.POPE_AUDIO,
  }
}